import React from 'react';
import ServiceListItem from '../ServiceListItem';
import JsxHelper from '../../Helpers/JsxHelper';
import LookupText from '../../Elements/LookupText';
import LookupTextLookupItemIdArray from '../../Elements/LookupTextLookupItemIdArray';

export default class BareIfyServiceItem extends ServiceListItem {
  static FieldsToShowInListTable = [
    ...ServiceListItem.generalTab,
    {
      tabName: 'Fieldwork',
      tabLabel: 'Fieldwork',
      icon: 'fa-solid fa-briefcase',
      data: [
        { name: 'ChecklistDetails', label: 'Checklist Details' },
        { name: 'AuditSchedule', label: 'Audit Schedule' },
        { name: 'UserRoles', label: 'User Roles' },
      ],
    },
    {
      tabName: 'Reporting',
      tabLabel: 'Reporting',
      icon: 'fa-solid fa-file-lines',
      data: [
        { name: (item) => Array.isArray(item.ReportingRequirements) ? item.ReportingRequirements.join(', ') : (item.ReportingRequirements || ''), label: 'Reporting Requirements' },
        { name: 'ExportsRequired', label: 'Exports required?' },
        { name: (item) => JsxHelper.YesNo(item.ActionItemsPlans), label: 'Action Items/Plans?' },
        { name: (item) => JsxHelper.YesNo(item.Apirequirement), label: 'API Requirement?' },
      ],
    },
    {
      tabName: 'AuditSurvey',
      tabLabel: 'Audit Survey',
      icon: 'fa-solid fa-clipboard-check',
      data: [
        { name: 'NumAuditSurveys', label: 'No. of Audit Surveys (Area to audit)' },
        { name: 'ApproxNumQuestionsPerSurvey', label: 'Approx. No. of Questions per Survey' },
        { name: 'NumOpenQuestions', label: 'No. Simple Text Questions' },
        { name: 'NumNarrativeQuestions', label: 'No. Narrative Questions' },
        { name: (item) => <LookupTextLookupItemIdArray lookupId={20} valueArray={item.RequiredLanguageCode} />, label: 'Required Language(s) Reporting' },
        { name: (item) => <LookupText lookupId={21} value={item.DataCaptureMethodCode} />, label: 'Data Capture Method' },
        { name: 'OtherDataCaptureMethod', label: 'Other Data Capture Method Description' },
        { name: (item) => JsxHelper.YesNo(item.QuestionnaireProvided), label: 'Questionnaire Provided by Client?' },
        { name: (item) => JsxHelper.YesNo(item.CollaborationInDataSoftware), label: 'Will Collaboration be Used in Data Software?' },
        { name: 'Mspplatform', label: 'MSP Platform' },
        { name: (item) => JsxHelper.YesNo(item.GuidelinesProvided), label: 'Guidelines Provided by Client?' },
      ],
    },
    ...ServiceListItem.commonEndTabs,
  ];
}
